export const blockIconsAudioandvideoPlaylistAddNew = (
	<span className='material-symbols-outlined'>playlist_add</span>
);
